import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import PageSEO from '@/components/feature/PageSEO';
import { Link } from 'react-router-dom';
import { useState } from 'react';

const milestones = [
  { year: '2018', title: '品牌创立', desc: '91传媒在北京成立，以内容营销服务切入市场' },
  { year: '2019', title: '服务升级', desc: '拓展广告投放与品牌推广业务线，服务客户突破100家' },
  { year: '2020', title: '技术驱动', desc: '上线自主研发的数据分析平台，实现数据驱动决策' },
  { year: '2021', title: '规模扩张', desc: '在上海、深圳、成都设立分公司，团队规模突破300人' },
  { year: '2022', title: '生态构建', desc: '推出创作者扶持计划，构建内容创作者生态体系' },
  { year: '2023', title: '行业领先', desc: '服务客户突破3000家，年营收突破5亿元' },
  { year: '2024', title: 'AI赋能', desc: '全面引入AI辅助创作工具，推出智能内容运营解决方案' },
  { year: '2025', title: '全球视野', desc: '启动国际化战略，服务覆盖东南亚及北美市场' },
];

const testimonials = [
  {
    name: '张瑞',
    role: '某知名消费品牌市场总监',
    content: '与91传媒合作三年，从最初的单次内容投放到现在的全案品牌策略合作，他们的专业度和执行力让我们非常放心。数据表现每次都超出预期，已经是我们最重要的营销合作伙伴。',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20executive%20portrait%2C%20confident%20business%20look%2C%20warm%20studio%20lighting%2C%20minimalist%20gray%20background%2C%20headshot%20photography&width=100&height=100&seq=testimonial-01&orientation=squarish',
  },
  {
    name: '李思瑶',
    role: '头部MCN机构创始人',
    content: '91传媒的数据分析平台让我们的内容决策从凭感觉变成了有据可依。通过他们的工具，我们的爆款率提升了近40%，这在竞争激烈的短视频赛道是巨大的优势。',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20entrepreneur%20portrait%2C%20modern%20business%20casual%2C%20warm%20lighting%2C%20minimalist%20background%2C%20headshot%20photography&width=100&height=100&seq=testimonial-02&orientation=squarish',
  },
  {
    name: '王建国',
    role: '某上市企业品牌副总裁',
    content: '91传媒团队对品牌的理解深度超出了我们的预期。他们不只是执行方，更是策略伙伴。好几个品牌战役的创意方向都是从他们团队的建议中获得的灵感。',
    avatar: 'https://readdy.ai/api/search-image?query=Senior%20Chinese%20male%20executive%20portrait%2C%20distinguished%20professional%20look%2C%20warm%20lighting%2C%20minimalist%20background%2C%20headshot%20photography&width=100&height=100&seq=testimonial-03&orientation=squarish',
  },
];

const faqs = [
  {
    q: '91传媒主要提供哪些服务？',
    a: '91传媒提供全方位的数字传媒解决方案，核心服务包括：内容创作（图文、短视频、直播等）、广告投放（信息流、搜索、社交媒体广告）、品牌推广（品牌策略、IP打造、KOL合作）、数据分析（内容效果追踪、用户画像分析）、自媒体运营（多平台矩阵搭建与内容变现）以及行业资讯与研究服务。',
  },
  {
    q: '如何与91传媒开展合作？',
    a: '合作流程简单高效：您可以通过本页面的合作咨询表单提交需求，我们的商务团队会在24小时内与您取得联系，了解您的具体需求后制定定制化方案。初次合作可从小规模试单开始，效果满意后逐步扩大合作范围。',
  },
  {
    q: '91传媒的服务收费标准是怎样的？',
    a: '我们采用灵活的收费模式，根据项目类型和复杂度定制报价。内容创作按条/项目计费，广告投放按消耗金额收取服务费，品牌全案按项目打包收费。具体价格请通过合作咨询表单获取详细报价方案。',
  },
  {
    q: '91传媒的数据分析能力如何保障？',
    a: '91传媒拥有自主研发的数据中台系统，已接入抖音、快手、小红书、B站、视频号等主流平台的数据接口，支持跨平台数据聚合分析。我们的数据团队由前互联网大厂数据科学家带队，确保数据分析的准确性和洞察深度。',
  },
  {
    q: '创作者如何加入91传媒生态？',
    a: '创作者可通过本页面提交申请，我们的创作者运营团队审核后（通常3个工作日内），符合条件的创作者将获得：平台流量扶持、商业合作对接、内容创作工具和专业培训资源等全方位赋能服务。目前我们已累计服务超过5000位创作者。',
  },
];

export default function AboutPage() {
  const [formStatus, setFormStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = (form.elements.namedItem('phone_alt') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setFormStatus('success');
      return;
    }
    setFormStatus('submitting');
    setFormError('');
    try {
      const formData = new FormData(form);
      formData.delete('phone_alt');
      const response = await fetch('https://readdy.ai/api/form/d9q9cocnlsngrm4lltng', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed: Record<string, unknown> = {};
      try { parsed = JSON.parse(responseText); } catch { /* ignore */ }
      if (response.ok && (parsed as { code?: string }).code === 'OK') {
        setFormStatus('success');
        form.reset();
      } else {
        const serverMsg = (parsed as { meta?: { message?: string } })?.meta?.message
          || (parsed as { message?: string })?.message
          || responseText;
        setFormError(typeof serverMsg === 'string' ? serverMsg : '提交失败，请稍后重试');
        setFormStatus('error');
      }
    } catch {
      setFormError('网络错误，请检查网络后重试');
      setFormStatus('error');
    }
  };

  return (
    <>
      <PageSEO />
      <Navbar />
      <main className="min-h-screen bg-background-50 pt-16">
        <nav className="max-w-7xl mx-auto px-4 md:px-6 pt-10 md:pt-14" aria-label="面包屑导航">
          <div className="flex items-center gap-2 text-sm text-foreground-500 flex-wrap">
            <Link to="/" className="hover:text-primary-600 transition-colors cursor-pointer">首页</Link>
            <i className="ri-arrow-right-s-line text-xs"></i>
            <span className="text-foreground-800 font-medium">关于我们</span>
          </div>
        </nav>

        {/* Hero Banner */}
        <section className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-20 text-center">
          <h1 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 mb-5">
            关于<span className="text-primary-500">91传媒</span>
          </h1>
          <p className="text-sm md:text-base text-foreground-600 max-w-3xl mx-auto leading-relaxed">
            91传媒成立于2018年，是专注于数字内容传播与媒体服务的综合平台。
            我们致力于通过内容创意、数据技术和资源整合，帮助创作者实现内容价值最大化，
            助力品牌主达成高效传播目标。经过多年的深耕发展，91传媒已成长为行业领先的传媒服务品牌。
          </p>
        </section>

        {/* Brand Story */}
        <section className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-20">
          <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
            <div className="flex-1">
              <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
                品牌故事
              </span>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-5">
                让每一份内容都掷地有声
              </h2>
              <div className="space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
                <p>
                  91传媒的创立源于一个朴素的观察：在信息爆炸的时代，优质内容常常被淹没在海量噪音之中。创作者花费大量心力产出的内容得不到应有的传播，品牌的营销预算被低效消耗。
                </p>
                <p>
                  我们决定改变这种状况。从最初的内容营销服务起步，91传媒逐步构建了覆盖内容创作、广告投放、品牌推广和数据分析的全链路服务体系。我们相信，好的内容值得被更多人看见，而技术和数据可以帮助实现这一点。
                </p>
                <p>
                  今天，91传媒已服务超过5000位创作者和300家品牌主，帮助他们在数字媒体生态中获得持续增长。但这只是一个开始，我们的使命是让数字内容传播变得更高效、更精准、更有价值。
                </p>
              </div>
            </div>
            <div className="flex-1 w-full">
              <div className="rounded-xl overflow-hidden h-72 md:h-96">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20creative%20office%20workspace%20with%20diverse%20team%20collaborating%20around%20a%20large%20table%2C%20warm%20natural%20lighting%2C%20plants%20and%20creative%20decor%2C%20professional%20yet%20relaxed%20atmosphere%2C%20minimalist%20design&width=800&height=600&seq=about-brand-story&orientation=landscape"
                  alt="91传媒团队办公场景"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Milestones */}
        <section className="py-14 md:py-20 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12 md:mb-16">
              <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
                发展历程
              </span>
              <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
                八年深耕，步步为营
              </h2>
            </div>
            <div className="relative">
              <div className="hidden lg:block absolute left-1/2 top-0 bottom-0 w-px bg-background-300/60 -translate-x-1/2"></div>
              <div className="space-y-8 lg:space-y-0">
                {milestones.map((m, i) => (
                  <div
                    key={m.year}
                    className={`flex flex-col lg:flex-row items-start gap-6 lg:gap-12 ${
                      i % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
                    } ${i > 0 ? 'lg:-mt-4' : ''}`}
                  >
                    <div className={`flex-1 ${i % 2 === 0 ? 'lg:text-right' : 'lg:text-left'}`}>
                      <div className="lg:hidden flex items-center gap-4 mb-3">
                        <span className="text-lg font-heading font-bold text-primary-500">{m.year}</span>
                        <span className="text-sm font-semibold text-foreground-800">{m.title}</span>
                      </div>
                      <div className="hidden lg:block">
                        <span className="text-lg font-heading font-bold text-primary-500">{m.year}</span>
                        <h4 className="text-base font-semibold text-foreground-800 mt-1">{m.title}</h4>
                        <p className="text-sm text-foreground-600 mt-1.5">{m.desc}</p>
                      </div>
                    </div>

                    <div className="hidden lg:flex w-4 h-4 rounded-full bg-primary-500 border-2 border-background-100 flex-shrink-0 relative z-10"></div>

                    <div className="flex-1 lg:hidden">
                      <p className="text-sm text-foreground-600">{m.desc}</p>
                    </div>
                    <div className="hidden lg:block flex-1"></div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Testimonials */}
        <section className="py-14 md:py-20 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12 md:mb-16">
              <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
                客户口碑
              </span>
              <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
                合作伙伴的真实评价
              </h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {testimonials.map((t) => (
                <div
                  key={t.name}
                  className="p-6 rounded-xl bg-background-100 border border-background-200/70"
                >
                  <div className="flex items-center gap-1 mb-4 text-accent-500">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-sm"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-5">
                    &ldquo;{t.content}&rdquo;
                  </p>
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                      <img src={t.avatar} alt={t.name} className="w-full h-full object-cover" />
                    </div>
                    <div>
                      <div className="text-sm font-semibold text-foreground-800">{t.name}</div>
                      <div className="text-xs text-foreground-500">{t.role}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="py-14 md:py-20 bg-background-100">
          <div className="max-w-3xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10 md:mb-14">
              <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
                常见问题
              </span>
              <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
                关于91传媒，你可能想了解
              </h2>
            </div>
            <div className="space-y-3">
              {faqs.map((faq, i) => (
                <details key={i} className="group rounded-xl bg-background-50 border border-background-200/70 overflow-hidden cursor-pointer">
                  <summary className="flex items-center justify-between p-5 text-sm md:text-base font-medium text-foreground-800 list-none">
                    {faq.q}
                    <i className="ri-add-line text-foreground-400 group-open:hidden"></i>
                    <i className="ri-subtract-line text-foreground-400 hidden group-open:block"></i>
                  </summary>
                  <div className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed">
                    {faq.a}
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>

        {/* Contact Form */}
        <section className="py-14 md:py-20 bg-background-50">
          <div className="max-w-2xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
                合作咨询
              </span>
              <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
                让我们携手共创
              </h2>
              <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto leading-relaxed">
                无论您是品牌主、创作者还是合作伙伴，填写以下表单，我们的团队将在24小时内与您取得联系
              </p>
            </div>

            <form
              data-readdy-form
              onSubmit={handleSubmit}
              className="space-y-5 p-6 md:p-8 rounded-xl bg-background-100 border border-background-200/70"
            >
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                <div>
                  <label htmlFor="name" className="block text-sm font-medium text-foreground-700 mb-1.5">姓名 *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    required
                    className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-300/60 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-colors"
                    placeholder="请输入您的姓名"
                  />
                </div>
                <div>
                  <label htmlFor="company" className="block text-sm font-medium text-foreground-700 mb-1.5">公司/机构</label>
                  <input
                    type="text"
                    id="company"
                    name="company"
                    className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-300/60 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-colors"
                    placeholder="请输入您的公司或机构名称"
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-foreground-700 mb-1.5">电子邮箱 *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-300/60 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-colors"
                    placeholder="请输入您的电子邮箱"
                  />
                </div>
                <div>
                  <label htmlFor="phone" className="block text-sm font-medium text-foreground-700 mb-1.5">联系电话</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-300/60 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-colors"
                    placeholder="请输入您的联系电话"
                  />
                </div>
              </div>

              <div>
                <label htmlFor="service" className="block text-sm font-medium text-foreground-700 mb-1.5">感兴趣的服务</label>
                <select
                  id="service"
                  name="service"
                  className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-300/60 text-sm text-foreground-800 focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-colors cursor-pointer"
                >
                  <option value="">请选择您感兴趣的服务</option>
                  <option value="内容创作">内容创作</option>
                  <option value="广告投放">广告投放</option>
                  <option value="品牌推广">品牌推广</option>
                  <option value="数据分析">数据分析</option>
                  <option value="自媒体运营">自媒体运营</option>
                  <option value="综合合作">综合合作</option>
                </select>
              </div>

              <div>
                <label htmlFor="message" className="block text-sm font-medium text-foreground-700 mb-1.5">
                  合作需求描述 * <span className="text-foreground-400 font-normal">（限500字）</span>
                </label>
                <textarea
                  id="message"
                  name="message"
                  required
                  maxLength={500}
                  rows={4}
                  className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-300/60 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-colors resize-none"
                  placeholder="请简要描述您的合作需求，以便我们为您精准匹配服务方案"
                ></textarea>
                <style>{`
                  #phone_alt_wrapper { position: absolute; left: -9999px; opacity: 0; pointer-events: none; }
                `}</style>
                <div id="phone_alt_wrapper">
                  <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
                </div>
              </div>

              {formError && (
                <div className="p-3 rounded-lg bg-primary-50 text-primary-700 text-sm">
                  {formError}
                </div>
              )}
              {formStatus === 'success' && (
                <div className="p-3 rounded-lg bg-accent-100 text-accent-700 text-sm">
                  提交成功！我们的团队将在24小时内与您联系。
                </div>
              )}

              <button
                type="submit"
                disabled={formStatus === 'submitting'}
                className="w-full py-3 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 disabled:opacity-60 disabled:cursor-not-allowed transition-colors duration-200 cursor-pointer whitespace-nowrap"
              >
                {formStatus === 'submitting' ? '提交中...' : '提交咨询'}
              </button>
            </form>

            <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-5 text-center">
              <div className="p-5 rounded-xl bg-background-100 border border-background-200/70">
                <div className="w-10 h-10 mx-auto flex items-center justify-center rounded-full bg-primary-50 text-primary-500 mb-3">
                  <i className="ri-phone-line text-lg"></i>
                </div>
                <div className="text-xs text-foreground-500 mb-1">客服热线</div>
                <div className="text-sm font-semibold text-foreground-800">400-891-8888</div>
              </div>
              <div className="p-5 rounded-xl bg-background-100 border border-background-200/70">
                <div className="w-10 h-10 mx-auto flex items-center justify-center rounded-full bg-accent-50 text-accent-500 mb-3">
                  <i className="ri-mail-line text-lg"></i>
                </div>
                <div className="text-xs text-foreground-500 mb-1">商务邮箱</div>
                <div className="text-sm font-semibold text-foreground-800">business@91media.com</div>
              </div>
              <div className="p-5 rounded-xl bg-background-100 border border-background-200/70">
                <div className="w-10 h-10 mx-auto flex items-center justify-center rounded-full bg-secondary-50 text-secondary-500 mb-3">
                  <i className="ri-map-pin-line text-lg"></i>
                </div>
                <div className="text-xs text-foreground-500 mb-1">总部地址</div>
                <div className="text-sm font-semibold text-foreground-800">北京市朝阳区传媒产业园A座</div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}